import React, { useMemo } from 'react';
import { motion } from 'motion/react';
import { EASE_OUT } from './tokens';
import usePrefersReducedMotion from './usePrefersReducedMotion';

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.055,
      delayChildren: 0.04,
    },
  },
};

const wordVariants = {
  hidden: { y: '115%', opacity: 0, filter: 'blur(4px)' },
  visible: {
    y: '0%',
    opacity: 1,
    filter: 'blur(0px)',
    transition: { duration: 0.48, ease: EASE_OUT },
  },
};

export default function AnimatedText({
  text,
  className = '',
  as: Component = 'span',
  delay = 0,
}) {
  const reduced = usePrefersReducedMotion();
  const words = useMemo(() => String(text || '').trim().split(/\s+/).filter(Boolean), [text]);
  const MotionTag = motion[Component] || motion.span;

  if (!text) return null;

  if (reduced) {
    return <Component className={className}>{text}</Component>;
  }

  return (
    <MotionTag
      className={className}
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      transition={{ delayChildren: delay }}
      aria-label={text}
    >
      {words.map((word, i) => (
        <span
          key={`${word}-${i}`}
          className="inline-block overflow-hidden align-bottom me-[0.28em] last:me-0"
          aria-hidden="true"
        >
          <motion.span className="inline-block will-change-transform" variants={wordVariants}>
            {word}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}
